@if (vesselId() && endpoint()) {
<core-generic-table [endpoint]="endpoint()" [columns]="columns()" [modalFields]="modalFields()" [actions]="actions()"
    [modelFactory]="modelFactory" [title]="'vessels.decks.table_title' | translate"
    [listTitle]="'vessels.decks.list_title' | translate" [showFilter]="false" [showCreateButton]="true"
    [showSelection]="false" [enablePagination]="true" (modalData)="onModalData($event)"
    [globalActions]="globalCustomActions()" class="o-layout__section">
</core-generic-table>
} @else {
<div class="c-empty-state u-card">
    <p>{{ 'service_subgroups.loading' | translate }}</p>
</div>
}